<ng-container *transloco="let t">
<ion-header>
	<ion-toolbar>
		@if (!['landing', 'login', 'register'].includes(title())) {
			<ion-buttons slot="start">
				@if (isAuthenticated()) {
					<ion-menu-button></ion-menu-button>
				}
				@if (title() !== 'home') {
					<ion-back-button [defaultHref]="backHref() ?? translateService.localize(isAuthenticated() ? '/app/home' : '/landing')" text=""></ion-back-button>
				}
			</ion-buttons>
		} @else if (['login', 'register'].includes(title())) {
			<ion-buttons slot="start">
				<ion-button [routerLink]="translateService.localize('/landing')" fill="clear" aria-label="Retour">
					<ion-icon name="chevron-back-outline" aria-hidden="true"></ion-icon>
				</ion-button>
			</ion-buttons>
		}
		@if (!isAuthenticated() && (shouldShowLoginButton() || title() === 'landing')) {
			<ion-buttons slot="end">
				<ion-button href="login" class="m-auto button" fill="outline" shape="round"
				            id="login">{{t("landing.button_login")}}</ion-button>
			</ion-buttons>
		} @else if (title() !== 'landing') {
			<ion-title class="toolbar-text" slot="start">
				<ion-icon class="toolbar-icon" name="{{icon()}}" aria-hidden="true"></ion-icon>
				<span class="toolbar-title-text">
					@if (translateTitle()) {
						{{t('page.label.' + title())}}
					} @else {
						{{ title() }}
					}
				</span>
			</ion-title>
		}
		<ion-buttons slot="end" class="lang-select-buttons">
			<app-language-button [onLanguageChanged]="onLanguageChanged"></app-language-button>
		</ion-buttons>
	</ion-toolbar>
</ion-header>
</ng-container>
